import { makeStyles } from 'tss-react/mui';

// Styles
import { cardRoundedShadow } from '../../../styles/global';

export const useStyles = makeStyles()((theme, { isKiteUser } = {}) => ({
  header: {
    [theme.breakpoints.down('md')]: {
      columnGap: theme.spacing(1.25),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        columnGap: theme.spacing(1.25),
      }),
    },
  },
  card: {
    ...cardRoundedShadow,
    borderRadius: '10px',

    '& > *:first-child': {
      padding: '10px 12px',
    },

    '& p': {
      margin: 0,
      padding: '10px 12px',
      ...(isKiteUser ? theme.typography.textSm : theme.typography.textMd),
      color: theme.palette.darkGrey,
    },

    '& [data-testid="collapse-button"]': {
      '& > rect:nth-child(2)': {
        fill: isKiteUser && theme.palette.primary1,
      },
      '& > rect:nth-child(3)': {
        fill: isKiteUser && theme.palette.primary1,
      },
    },
  },
}));
